export const SELECTED_DISHES_CATEGORY_ID = -2;
export const ALL_DISHES_CATEGORY_ID = -1;
